import React from "react";
import logo from "../images/KrossKast_Logo-red.png";
import BrandManagerSidebar from "./BrandManagerSidebar";
import AuthenticatedUserMenu from "./AuthenticatedUserMenu";
import "../brandmanager.css";

/**
 * Brand Manager chrome (top nav + Brand Manager sidebar).
 * User identity control is the shared AuthenticatedUserMenu (same as MasterLayout).
 */
export default function BrandManagerShell({ children }) {
  return (
    <div className="brand-manager-page" data-testid="brand-manager-shell">
      <div className="top-nav">
        <img src={logo} alt="KrossKast" className="nav-logo" />
        <AuthenticatedUserMenu />
      </div>

      <div className="brand-manager-content">
        <BrandManagerSidebar />
        <div className="main-area">{children}</div>
      </div>
    </div>
  );
}
